module.exports = __webpack_public_path__ + "img/customer-support.d5443951.svg";